import { Popover, Transition } from "@headlessui/react";
import classNames from "classnames";
import { t } from "@/i18n-js/instance";
import type {
  HeaderNavItemKind,
  HeaderNavItemVisibility,
} from "@circle-react/components/SettingsApp/Navigation/hooks/useFetchHeaderNavItems";
import { useSidebarBorderStyles } from "@circle-react/components/Spaces/SidebarV2/hooks";
import { Icon } from "@circle-react-shared/Icon";
import { popOverInOut } from "@circle-react-shared/uikit/animations";
import { NavigationLink } from "../NavigationItem";

const i18nRoot = "header_v3.navigation";

interface Item {
  kind: HeaderNavItemKind;
  label: string;
  linkTo: string;
  openInNewWindow?: boolean;
  visibility: HeaderNavItemVisibility;
}
export interface MorePopoverProps {
  isPreviewMode?: boolean;
  items: Item[];
}

export const MorePopover = ({
  items,
  isPreviewMode = false,
}: MorePopoverProps) => {
  const { borderColor } = useSidebarBorderStyles();

  return (
    <Popover className="relative">
      {/* eslint-disable-next-line @typescript-eslint/unbound-method -- Updating typescript-eslint, should be fixed when appropriate */}
      {({ open, close }) => (
        <>
          <Popover.Button
            disabled={isPreviewMode}
            className={classNames(
              "text-xs-plus h-8.5 focus-visible:outline-secondary flex items-center !rounded-full py-2 pl-4 pr-2 font-medium transition-colors duration-150 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2",
              "hover:bg-c-header-hover text-c-header hover:text-c-header-active focus:text-c-header-active focus:bg-c-header-hover",
              {
                "bg-c-header-hover text-c-header-active": open,
              },
            )}
          >
            <span className="flex gap-0.5">
              {t([i18nRoot, "more"])}
              <Icon
                type="12-chevron-down-v3"
                className="!transition-none"
                size={12}
              />
            </span>
          </Popover.Button>
          <Transition {...popOverInOut}>
            <Popover.Panel
              className="bg-c-header absolute right-0 top-1.5 flex w-max flex-col rounded-2xl border p-4 shadow-lg"
              style={{ borderColor }}
            >
              {items.map(
                ({ linkTo, label, kind, visibility, openInNewWindow }) => (
                  <NavigationLink
                    key={linkTo}
                    label={label}
                    linkTo={linkTo}
                    isFullRounded={false}
                    isActive={false}
                    onClick={close}
                    kind={kind}
                    visibility={visibility}
                    openInNewWindow={openInNewWindow}
                  />
                ),
              )}
            </Popover.Panel>
          </Transition>
        </>
      )}
    </Popover>
  );
};
